// src/components/NotFoundPage.js

import React from 'react';
import { Helmet } from 'react-helmet-async';
import SEO from './SEO'; // Adjust path if SEO.js is not in the same directory

const NotFoundPage = () => {
  return (
    <>
      {/* SEO: Set specific metadata for the 404 page */}
      {/* This helps search engines understand it's intentionally not found content */}
      <SEO
         title="Page Not Found - Jimatly" // Include your site name in the title
         description="Sorry, the page you were looking for on Jimatly doesn't exist."
         canonical="https://www.jimatly.com/404" // Standard practice to canonicalize 404s to a consistent URL
         // ogImage - you could add a default ogImage for the 404 page if you like
      />

      {/* Visible content for the user */}
      <div style={{ textAlign: 'center', marginTop: '50px' }}>
        <h1>404 - Page Not Found</h1>
        <p>The page you were looking for doesn't exist or has been moved.</p>
        {/* Link back to the homepage */}
        <a href="/" style={{ textDecoration: 'underline', color: 'blue' }}>Go to Homepage</a>
      </div>
    </>
  );
};

export default NotFoundPage;